// EntitlementAdjustmentDetails — the entitlement-adjustment specifics the
// generic ResourceAccessView can't show: WHICH entitlements were flagged and
// WHY. Parsed from the assignment `body` (already on the client via the task
// list) — see taskMeta.parseEntitlementAdjustment. Renders nothing when the
// body carries neither.

import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { TbAlertTriangle } from "react-icons/tb";

import SectionHeader from "components/ds/SectionHeader";

import { parseEntitlementAdjustment } from "./taskMeta";

const Card = ({ children }: { children: React.ReactNode }) => (
  <Box borderWidth="1px" borderColor="neutral.200" borderRadius="10px" bg="neutral.25" p="md">
    {children}
  </Box>
);

const EntitlementAdjustmentDetails = ({ body }: { body?: string | null }) => {
  const { entitlements, reason } = parseEntitlementAdjustment(body);
  if (entitlements.length === 0 && !reason) return null;

  return (
    <>
      {entitlements.length > 0 && (
        <Box>
          <SectionHeader>Entitlements to adjust</SectionHeader>
          <Card>
            <Flex direction="column" gap="sm">
              {entitlements.map((name) => (
                <Flex key={name} align="center" gap="sm">
                  <Icon as={TbAlertTriangle} boxSize="14px" color="warning.600" flexShrink={0} />
                  <Text fontSize="smd" fontWeight={500} color="neutral.950" wordBreak="break-word">
                    {name}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Card>
        </Box>
      )}

      {reason && (
        <Box>
          <SectionHeader>Reason for adjustment</SectionHeader>
          <Card>
            <Text fontSize="smd" color="neutral.800" whiteSpace="pre-wrap" wordBreak="break-word">
              {reason}
            </Text>
          </Card>
        </Box>
      )}
    </>
  );
};

export default EntitlementAdjustmentDetails;
